import { useEffect, useState } from 'react';
import { View } from 'react-native';

import { Text, COLORS } from '../Basics';
import { useStore } from '../../store/Context';

/**
 * Indicador de estado preditivo (evento 131 / ictiLIN_URAT).
 */
export const PredictiveStatus = () => {
  const [state, setState] = useState(null);

  useEffect(() => {
    const onBusy = ev => setState(ev.detail || ev.data || null);
    const onClear = () => setState(null);

    document.addEventListener('lorentz:predictive:busy', onBusy);
    document.addEventListener('lorentz:predictive:cleared', onClear);
    document.addEventListener('lorentz:cti:ring', onClear);

    return () => {
      document.removeEventListener('lorentz:predictive:busy', onBusy);
      document.removeEventListener('lorentz:predictive:cleared', onClear);
      document.removeEventListener('lorentz:cti:ring', onClear);
    };
  }, []);

  if (!state) return null;

  return (
    <View
      style={{
        backgroundColor: '#c62828',
        padding: 8,
        borderRadius: 6,
        marginBottom: 8
      }}
    >
      <Text style={{ color: '#fff', fontWeight: 'bold', fontSize: 13 }}>
        OCUPADO PREDITIVO
      </Text>
      {state.contact || state.phone ? (
        <Text style={{ color: '#ffcdd2', fontSize: 12, marginTop: 2 }}>
          {[state.contact, state.phone].filter(Boolean).join(' · ')}
        </Text>
      ) : null}
      {state.cpf ? (
        <Text style={{ color: '#ffcdd2', fontSize: 12 }}>CPF: {state.cpf}</Text>
      ) : null}
    </View>
  );
};

export default PredictiveStatus;
